import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi
} from '@angular/common/http';
import {ApplicationConfig, importProvidersFrom, InjectionToken, makeEnvironmentProviders} from '@angular/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, provideMomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_TABS_CONFIG} from '@angular/material/tabs';
import {PreloadAllModules, provideRouter, withPreloading, withRouterConfig} from '@angular/router';
import {environment} from '../environments/environment';

import {routes} from './modules/routing/app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {BasicAuthInterceptor} from './core/interceptors/basic-auth.interceptor';
import {ErrorCatchingInterceptor} from './core/interceptors/error-catching.interceptor';
import {returnURLInterceptor} from './core/interceptors/return-url.interceptor';
import {CustomDateAdapter} from './custom-date-adapter';
import {provideDialogConfig} from '@ngneat/dialog';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {ApiService} from './modules/apiModule1/api/ApiService';
import {ApiModule,Configuration, ConfigurationParameters} from './modules/apiModule1';

// export function apiConfigFactory(): Configuration {
//   const params: ConfigurationParameters = {
//     // TODO: token
//     // credentials: { Bearer: () => `Bearer <token>` },
//     basePath: environment.api_url
//   };
//   return new Configuration(params);
// }
export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    basePath: environment.api_url.replace(/\/+$/, '')
  };
  return new Configuration(params);
}

export const USERKEY = new InjectionToken<string>('user-key');
export const REFRESH_KEY = new InjectionToken<string>('refresh-key');
export const RETURN_URL = new InjectionToken<string>('return-url');
export const MAT_DIALOG_SERVICE = new InjectionToken<ApiService>('mat-dialog-service');
export const MAT_DIALOG_METHOD = new InjectionToken<string>('mat-dialog-method');

export const USER_TABLE_POSTFIX = new InjectionToken<string>('user-table-postfix');
export const USER_TABLE_SORT_POSTFIX = new InjectionToken<string>('user-table-sort-postfix');
export const USER_TABLE_SORT_SEPARATED_POSTFIX = new InjectionToken<string>('user-table-sort-separated-postfix');

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules),
      withRouterConfig({paramsInheritanceStrategy: 'always'})),
    provideClientHydration(),
    provideAnimationsAsync(),
    importProvidersFrom(ApiModule.forRoot(apiConfigFactory)),
    provideHttpClient(
      withFetch(),
      withInterceptors([returnURLInterceptor]),
      withInterceptorsFromDi()
    ),
    // {provide: ErrorHandler, useClass: GlobalErrorHandler},
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_DATE_LOCALE, useValue: 'ru-RU' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: USERKEY, useValue: 'auth-user' },
    { provide: REFRESH_KEY, useValue: 'refresh-user' },
    { provide: RETURN_URL, useValue: 'return-url' },
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorCatchingInterceptor, multi: true },
    provideDialogConfig({
      sizes: {
        sm: {
          width: 300, // 300px
          minHeight: 250, // 250px
        },
        md: {
          width: '60vw',
          height: '60vh',
        },
        lg: {
          width: '90vw',
          height: '90svh',
        },
        fullScreen: {
          width: '100vw',
          height: '100vh',
        },
      },
    }),
    provideMomentDateAdapter(MY_FORMATS),
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,useValue: {
      subscriptSizing: 'dynamic'
      }},
      {provide: USER_TABLE_POSTFIX, useValue: '-table'},
      {provide: USER_TABLE_SORT_POSTFIX, useValue: '-table-sort'},
      {provide: USER_TABLE_SORT_SEPARATED_POSTFIX, useValue: '-sort'},
  ]
};
